<select [id]="inputId()" class="form-select {{extraClasses()}}" (change)="onSelectionChange($event)" [disabled]="formField.state().disabled()" [attr.aria-describedby]="ariaDescribedBy()" [appFormField]="formField.field()">
  @if (placeholder(); as placeholderLabel) {
    <option value="" [selected]="formField.state().value() === null">{{placeholderLabel}}</option>
  }
  @for (opt of options(); track getEnumValue(opt)) {
    @let value = getEnumValue(opt);

    <option [value]="value" [selected]="value === formField.state().value()">
      @if (template(); as tmpl) {
        <ng-container [ngTemplateOutlet]="tmpl" [ngTemplateOutletContext]="{ $implicit: value }"></ng-container>
      } @else {
        {{ getEnumLabel(opt) | titlecase }}
      }
    </option>
  }
</select>
